
// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { formatText } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @components
const ShowData = require('../showData/showData');
const MyProfileEditorWizard = require('../myProfileEditor/MyProfileEditorWizard');
const { ConsentProfileSection } = require('components/myProfile/consentProfileSection/consentProfileSection');
const { DataAssignmentODM } = require('components/myProfile/dataAssignmentODM/dataAssignmentODM');
const { RightsProfileSection } = require('components/myProfile/rightsProfileSection/rightsProfileSection');
const { ConsentsChangeBox } = require('components/myProfile/consentsChangeBox/consentsChangeBox');
const { OpenYoungInformationProfileSection } = require('components/myProfile/openYoungInformationProfileSection/openYoungInformationProfileSection');
const FiscalProfileSection = require('components/myProfile/fiscalProfileSection/fiscalProfileSection');
const WebappRender = require('components/conditionalRender/webappRender');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const { getTranslatedCountry } = require('constants/countries');
const PROVINCES = require('constants/provinces');
const { OPEN_YOUNG, BASIC_ACCOUNT, OPEN_MARKETS_PERSONAL_DATA_CESSION, AGGREGATOR_CONSENTS } = require('constants/flagBasedFeatures');


class PersonalData extends React.Component {
    buildFormDataCC(previousData) {
        if (__CONTACT_CENTER__) {
            const { immProfileFields, immModifyMainPhone } = this.props;
            const phonesList = immModifyMainPhone.getIn(['mainContactPhoneData', 'listaDispositivos']).toJS();
            const immDevices = immProfileFields.getIn(['listaDispositivos', 'dispositivo']);

            if (immDevices && immDevices.size > 0) {
                const [
                    {
                        horaDesde: fromEmailContactTime,
                        horaHasta: toEmailContactTime
                    },
                    { horaDesde: fromPhoneContactTime,
                        horaHasta: toPhoneContactTime
                    }
                ] = immDevices.toJS();

                return Object.assign(previousData, { fromEmailContactTime, toEmailContactTime, fromPhoneContactTime, toPhoneContactTime, phonesList })

            } else {
                return previousData;
            }

        }
        return previousData;
    }

    buildSummary() {
        const {
            fiocDocumentation,
            flagBasedFeatures,
            immAccounts,
            immProfileFields,
            immProfileShippingAddress,
            setEditMode,
        } = this.props;
        const fullPhoneNumber = PersonalDataHelper.getPhoneNumber(immProfileFields);
        const email = PersonalDataHelper.getEmail(immProfileFields);
        const taxData = PersonalDataHelper.getTaxData(immProfileFields);
        const listCountries = PersonalDataHelper.getListCountriesWithAdditionalTaxing(immProfileFields);
        const address = PersonalDataHelper.getFormattedAddress(immProfileFields);
        const fullName = PersonalDataHelper.getFullName(immProfileFields, false);
        const canEdit = immProfileFields.get('isFetching');
        const formData = {
            address,
            birthCountry: getTranslatedCountry(taxData.birthCountry),
            birthProvince: PROVINCES[taxData.birthProvince],
            birthSquare: taxData.birthSquare,
            canEdit,
            flagBasedFeatures,
            fullName,
            email,
            fullPhoneNumber,
            immProfileShippingAddress,
            listCountries: {
                immCountries: listCountries
            },
            setEditMode,
            fiocDocumentation,
        };
        const newFormData = this.buildFormDataCC(formData);
        let consentProfileSection = <ConsentProfileSection />;
        let buildDataAssignmentODM = flagBasedFeatures.get(OPEN_MARKETS_PERSONAL_DATA_CESSION) && <DataAssignmentODM />;
        let consentsChangeBox = <ConsentsChangeBox />;

        // Only if the feature flag is true and all accounts are basic then we should hide the section
        if (flagBasedFeatures.get(BASIC_ACCOUNT) && immAccounts.get('byId').size && immAccounts.get('byId').every(immAccount => immAccount.get('isBasicAccount'))) {
            consentProfileSection = null;
        }
        if (!flagBasedFeatures.get(AGGREGATOR_CONSENTS)) {
            consentsChangeBox = null;
        }

        return (
            <div>
                <OKSectionBox title={formatText('profile-sectionTitle')}>
                    <section className="profile-edit-view__personal-data">
                        <ShowData
                            {...newFormData}
                        />
                    </section>
                </OKSectionBox>
                <FeatureTogglingRender notAllowedProductKey={OPEN_YOUNG} >
                    <OpenYoungInformationProfileSection />
                </FeatureTogglingRender>
                <WebappRender>
                    <FiscalProfileSection />
                </WebappRender>
                {consentProfileSection}
                {buildDataAssignmentODM}
                <RightsProfileSection />
                {consentsChangeBox}
            </div>
        );
    }

    render() {
        let profileForm = this.buildSummary();

        const {
            actionChangeValue,
            beforeLeaving,
            deleteAdditionalCountries,
            immProfileEditor,
            immProfileFields,
            isReady,
            onCancel,
            onConfirmLeave,
            onFinish,
            setVisibleStep,
            setField,
            setWillCancel,
            updateAdditionalCountries,
            validateStep,
            onHandleNextClick,
            onHandleSendOtpEmail,
            onHandleSetOtp,
            onHandleVerifyOtpEmail,
            otp,
            setEmailUuid,
            initProfileOtpEmail,
            resendOtpEmail,
            history,
        } = this.props;
        if (immProfileEditor.get('editMode')) {
            profileForm = (
                <MyProfileEditorWizard
                    actionChangeValue={actionChangeValue}
                    beforeLeaving={beforeLeaving}
                    immProfileFields={immProfileFields}
                    immProfileEditor={immProfileEditor}
                    isReady={isReady}
                    onCancel={onCancel}
                    onConfirmLeave={onConfirmLeave}
                    onFinish={onFinish}
                    setVisibleStep={setVisibleStep}
                    setField={setField}
                    setWillCancel={setWillCancel}
                    deleteAdditionalCountries={deleteAdditionalCountries}
                    updateAdditionalCountries={updateAdditionalCountries}
                    validateStep={validateStep}
                    onHandleNextClick={onHandleNextClick}
                    onHandleSendOtpEmail={onHandleSendOtpEmail}
                    onHandleSetOtp={onHandleSetOtp}
                    onHandleVerifyOtpEmail={onHandleVerifyOtpEmail}
                    otp={otp}
                    setEmailUuid={setEmailUuid}
                    initProfileOtpEmail={initProfileOtpEmail}
                    history={history}
                    resendOtpEmail={resendOtpEmail}
                />
            );
        }

        return profileForm;
    }
}

PersonalData.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    beforeLeaving: PropTypes.func.isRequired,
    children: PropTypes.any,
    deleteAdditionalCountries: PropTypes.func.isRequired,
    editable: PropTypes.bool.isRequired,
    fiocDocumentation: PropTypes.object,
    flagBasedFeatures: PropTypes.object.isRequired,
    onHandleNextClick: PropTypes.func,
    onHandleSendOtpEmail: PropTypes.func,
    onHandleSetOtp: PropTypes.func,
    immAccounts: PropTypes.object.isRequired,
    immModifyMainPhone: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object,
    immProfileFields: PropTypes.object,
    immProfileShippingAddress: PropTypes.object.isRequired,
    isReady: PropTypes.func.isRequired,
    maskContent: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirmLeave: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    setEditingTaxAdditionalCountry: PropTypes.func.isRequired,
    setEditMode: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    updateAdditionalCountries: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setEmailUuid: PropTypes.func,
};

module.exports = PersonalData;
